import React from 'react';
import { Route, RouteComponentProps, Switch, withRouter, Redirect } from 'react-router-dom';
import Loadable from 'react-loadable';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const LoadingWrapper = styled.div`
  width: 100%;
  height: 74vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Loading = () => (
  <LoadingWrapper>
    <Spin size="large" indicator={<LoadingOutlined style={{ fontSize: '50px' }} />} />
  </LoadingWrapper>
);

const Dashboard = Loadable({
  loader: () => import(/* webpackChunkName: 'Dashboard' */ 'components/dashboard'),
  loading: Loading,
});

const Transactions = Loadable({
  loader: () => import(/* webpackChunkName: 'orders' */ 'components/transactions'),
  loading: Loading,
});

const Payments = Loadable({
  loader: () => import('components/payments/routes'),
  loading: Loading,
});

const Analytics = Loadable({
  loader: () => import('components/analytics'),
  loading: Loading,
});

const RoleManage = Loadable({
  loader: () => import('components/account-manage/routes'),
  loading: Loading,
});

const Profile = Loadable({
  loader: () => import(/* webpackChunkName: 'orders' */ 'components/profile'),
  loading: Loading,
});

const TransactionDetail = Loadable({
  loader: () => import(/* webpackChunkName: 'orders' */ 'components/transaction-detail'),
  loading: Loading,
});

const PaymentLink = Loadable({
  loader: () => import('components/payment-link'),
  loading: Loading,
});

const Help = Loadable({
  loader: () => import(/* webpackChunkName: 'orders' */ 'components/help'),
  loading: Loading,
});

type IProps = RouteComponentProps<{ component: string }>;
class Routes extends React.Component<IProps, { hasError: boolean; errorInfo: React.ErrorInfo | null }> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      hasError: false,
      errorInfo: null,
    };
  }

  // componentDidUpdate(prevProps: RouteComponentProps<{ component: string }>) {
  //   if (prevProps.match.params.component !== this.props.match.params.component) {
  //     console.debug(prevProps.match.params, this.props.match.params);
  //   }
  // }

  // componentWillUnmount() {
  //   console.debug(ROUTE_CHANGE);
  // }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    this.setState({ hasError: true, errorInfo });
  }

  render() {
    return this.state.hasError ? (
      <>{this.state.errorInfo!.componentStack}</>
    ) : (
      <Switch>
        <Route exact path="/main/dashboard" component={Dashboard} />
        <Route exact path="/:merchantId/main/dashboard/" component={Dashboard} />
        <Route exact path="/main/transactions" component={Transactions} />
        <Route exact path="/:merchantId/main/transactions" component={Transactions} />
        <Route exact path="/main/transaction/:id" component={TransactionDetail} />
        <Route exact path="/:merchantId/main/transaction/:id" component={TransactionDetail} />
        <Route exact path="/main/profile" component={Profile} />
        <Route path="/main/payments/*" component={Payments} />
        <Route path="/main/analytics" component={Analytics} />
        <Route path="/main/accountManage/*" component={RoleManage} />
        <Route path="/main/payment-link" component={PaymentLink} />
        <Route exact path="/main/help" component={Help} />
        <Route render={() => <Redirect to={'/main/dashboard'} />} />
      </Switch>
    );
  }
}

export default withRouter(Routes);
